module.exports = __webpack_public_path__ + "img/item_chicken.2512d790.jpg";